module.exports = __webpack_public_path__ + "static/media/usersIcon.c27dc669.svg";